// Shared display vocabulary for producer stamps and interpreted source facts.
import { evidenceValueLabel } from "./sourceEvidence.js";

import { HARNESS_CATALOG } from "./harnessCatalog.js";

export const CLIENT_SURFACE_IDENTITIES = Object.freeze(Object.fromEntries(
  Object.entries(HARNESS_CATALOG.identities).map(([id, identity]) => [id, Object.freeze(identity)]),
));
export const CLAUDE_ENTRYPOINT_SURFACES = Object.freeze(HARNESS_CATALOG.maps.ENTRYPOINTS);

export function clientSurfaceIdentity(clientSurface) {
  const tag = typeof clientSurface === "string" ? clientSurface.trim().toLowerCase() : "";
  return Object.hasOwn(CLIENT_SURFACE_IDENTITIES, tag) ? CLIENT_SURFACE_IDENTITIES[tag] : null;
}

export function clientSurfaceLabel(clientSurface, { version = null, ide = false } = {}) {
  const identity = typeof clientSurface === "string" ? clientSurfaceIdentity(clientSurface) : clientSurface;
  if (!identity) return null;
  const host = evidenceValueLabel("host", identity.host);
  const name = !host && identity.genericName ? identity.genericName : identity.name;
  const product = `${name}${version ? ` ${version}` : ""}`;
  const label = host ? `${product} in ${host}` : product;
  return ide ? `${label} (IDE attached)` : label;
}

export function harnessIdentity(id) {
  id = String(id || "").replace(/^harness:/, "");
  const identity = Object.hasOwn(HARNESS_CATALOG.categories, id) ? CLIENT_SURFACE_IDENTITIES[id] : null;
  return identity ? { ...identity, name: clientSurfaceLabel(identity) }
    : { key: "unknown", name: Object.hasOwn(HARNESS_CATALOG.statuses, id) ? HARNESS_CATALOG.statuses[id] : HARNESS_CATALOG.statuses.unknown };
}

export function harnessTagsMatching(search) {
  const term = String(search ?? "").trim().toLowerCase();
  if (!term) return [];
  return [...Object.keys(HARNESS_CATALOG.categories), "unknown", "conflicting"]
    .filter(id => id.includes(term) || harnessIdentity(id).name.toLowerCase().includes(term))
    .map(id => `harness:${id}`);
}

export function normalizeHarnessName(value) {
  const id = String(value).replace(/^harness:/, "").toLowerCase();
  if (Object.hasOwn(HARNESS_CATALOG.categories, id) || ["unknown", "conflicting"].includes(id)) return `harness:${id}`;
  return harnessTagsMatching(value).find(id => harnessIdentity(id).name.toLowerCase() === value.toLowerCase()) || value;
}
